var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 19.9997C15.0003 21.1047 14.5613 22.1646 13.7799 22.946C12.9985 23.7274 11.9387 24.1663 10.8337 24.1663C9.72859 24.1663 8.66878 23.7274 7.88738 22.946C7.10598 22.1646 6.66699 21.1047 6.66699 19.9997C6.66699 18.8946 7.10598 17.8348 7.88738 17.0534C8.66878 16.272 9.72859 15.833 10.8337 15.833C11.9387 15.833 12.9985 16.272 13.7799 17.0534C14.5613 17.8348 15.0003 18.8946 15.0003 19.9997Z",
    stroke: "#F0CFAD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 10.833L15 16.6663M23.3333 29.1663L15 23.333",
    stroke: "#F0CFAD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6673 30.8333C31.6673 31.9384 31.2283 32.9982 30.4469 33.7796C29.6655 34.561 28.6057 35 27.5007 35C26.3956 35 25.3358 34.561 24.5544 33.7796C23.773 32.9982 23.334 31.9384 23.334 30.8333C23.334 29.7283 23.773 28.6685 24.5544 27.8871C25.3358 27.1057 26.3956 26.6667 27.5007 26.6667C28.6057 26.6667 29.6655 27.1057 30.4469 27.8871C31.2283 28.6685 31.6673 29.7283 31.6673 30.8333ZM31.6673 9.16667C31.6673 10.2717 31.2283 11.3315 30.4469 12.1129C29.6655 12.8943 28.6057 13.3333 27.5007 13.3333C26.3956 13.3333 25.3358 12.8943 24.5544 12.1129C23.773 11.3315 23.334 10.2717 23.334 9.16667C23.334 8.0616 23.773 7.00179 24.5544 6.22039C25.3358 5.43899 26.3956 5 27.5007 5C28.6057 5 29.6655 5.43899 30.4469 6.22039C31.2283 7.00179 31.6673 8.0616 31.6673 9.16667Z",
    stroke: "#F0CFAD",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon_share.cc7962d197ab08941c2f238089cca689.svg";
export { ForwardRef as ReactComponent };